<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role == 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role == 'CUSTOMER_CARE'"><a
        routerLink="/admin/customercareOrders/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/accountOwnerList/">Customers</a></li>
      <li class="breadcrumb-item active" aria-current="page">View Customer</li>
    </ol>
  </nav>
  <div class="row" [hidden]="user.role == 'SALES_MKTG' || user.role == 'CUSTOMER_CARE' ">
    <div class="col">
      <div class="text-right float-right">
        <button (click)="editCustomers()" class="btn btn-orange ml-2">Edit Customer</button>
      </div>
    </div>
  </div>
  <form>
    <div class="row mt-2">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"><b>Details</b></h2>
          <div class="row mt-3">
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Customer Name</b> : {{viewCustomer?.ownerName | titlecase}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Company Name</b> : {{viewCustomer?.companyName}}</label>
            </div>
            <div class="col-lg-4 col-sm-6" *ngIf="viewCustomer?.accountType == 'DEMO_ACCOUNT'">
              <label class="text-black"><b>Expiry Date</b> : {{viewCustomer?.expiryDate}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Email</b> : {{viewCustomer?.email}}</label>
            </div>
            <div class="col-lg-4 col-sm-6">
              <label class="text-black"><b>Phone Number</b> : {{viewCustomer?.mobile}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col">
        <div class="inner-box">
          <!-- <h2 class="text-black"><b>Details</b></h2> -->
          <div class="row mt-3">
            <div class="col-lg-4 col-sm-6" *ngIf="viewCustomer?.gstNumber != null">
              <label class="text-black"><b>GST</b> : {{viewCustomer?.gstNumber}}</label>
            </div>
            <div class="col-lg-4 col-sm-6" *ngIf="viewCustomer?.panCardNumber != null">
              <label class="text-black"><b>Pancard Number</b> : {{viewCustomer?.panCardNumber}}</label>
            </div>
            <div class="col-lg-4 col-sm-6" *ngIf="viewCustomer?.aadhartCardNumber != null">
              <label class="text-black"><b>Aadhar Number</b> : {{viewCustomer?.aadhartCardNumber}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngFor="let add of addresses">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-4">
              <label class="text-black"><b>Address Type</b> : {{add.addressType | titlecase}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-4">
                  <label class="text-black"><b>Address 1</b> : {{add.address1}}</label><br>
                </div>
                <div class="col-4">
                  <label class="text-black"><b>Address 2</b> : {{add.address2}}</label><br>
                </div>
                <div class="col-4">
                  <label class="text-black"><b>City</b> : {{add.city}}</label><br>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="text-black"><b>State</b> : {{add.state}}</label><br>
                </div>
                <div class="col-4">
                  <label class="text-black"><b>Zip</b> : {{add.zip}}</label><br>
                </div>
                <!-- <div class="col-4">
                   <label class="text-black"><b>Geo Code</b> : {{add.geoCode}}</label><br>
                 </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" *ngIf="viewCustomer?.codPaymentDays != null">
      <div class="col">
        <div class="inner-box">
          <h5>COD Payment Preferences</h5>
          <div class="row mt-2">
            <div class="col">
              <label class="text-black">Payment will be done after {{viewCustomer?.codPaymentDays}} days from product
                delivered</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3"
         [hidden]="viewCustomer?.mouDocument && viewCustomer?.panCard && viewCustomer?.aadharCard == 'NO' ">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"><b>Documents</b></h2>
          <label class="mt-2"> <a href="{{viewCustomer?.mouDocument}}" target="_blank">MOU Document</a></label><br>
          <label> <a href="{{viewCustomer?.panCard}}" target="_blank">Pancard </a></label><br>
          <label> <a href="{{viewCustomer?.aadharCard}}" target="_blank">Aadhar card </a></label>
        </div>
      </div>
    </div>
    <div class="inner-box mt-2">
      <h2>Orders</h2>
      <div class="row mt-3">
        <div class="col-md-4">
          <label><b>Total Count</b></label><br>
          {{viewCustomerOrderCount.totalOrders}}
        </div>
        <div class="col-md-4">
          <label><b>Orders Delivered</b></label><br>
          {{viewCustomerOrderCount.deliveredOrders}}
        </div>
        <div class="col-md-4">
          <label><b>RTO Count</b></label><br>
          {{viewCustomerOrderCount.returnOrders}}
        </div>
      </div>
    </div>

  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/accountOwnerList" class="btn btn-cancel">Close</button>
    </div>
  </div>
</div>
